import { graphql } from 'react-apollo';

import { compose, withProps } from 'recompose';

import user from 'js/lib/user';

import { PROGRAM_VISIBILITY_RULE } from 'bundles/enterprise-legacy-learner-home/constants/ProgramCommonConstants';
import { Member } from 'bundles/enterprise-legacy-learner-home/constants/ProgramMembershipState';
import type { ProgramMembershipsV2 } from 'bundles/naptimejs/resources/__generated__/ProgramMembershipsV2';
import type { ThirdPartyOrganizationsV1 } from 'bundles/naptimejs/resources/__generated__/ThirdPartyOrganizationsV1';
import type EnterpriseProgramsV1 from 'bundles/naptimejs/resources/enterprisePrograms.v1';
import ProgramHomeLoggedInQueryText from 'bundles/program-home/queries/ProgramHomeLoggedInQuery';
import type {
  ProgramHomeLoggedInQuery,
  ProgramHomeLoggedInQueryVariables,
} from 'bundles/program-home/queries/ProgramHomeLoggedInQuery';

type PropsFromCaller = {
  program: EnterpriseProgramsV1;
  thirdPartyOrganization: ThirdPartyOrganizationsV1;
};

export type PropsFromWithEnterpriseProgramMembership = {
  membershipCreatedAt?: number | null;
  programMembership?: ProgramMembershipsV2;
  isProgramMember: boolean;
  isMembershipLoading?: boolean;
};

type PropsFromWithProps = {
  userId: number;
};

const withEnterpriseProgramMembership = compose(
  withProps<PropsFromWithProps, {}>(() => ({
    userId: user.get().id,
  })),
  graphql<
    PropsFromCaller & PropsFromWithProps,
    ProgramHomeLoggedInQuery,
    ProgramHomeLoggedInQueryVariables,
    PropsFromWithEnterpriseProgramMembership
  >(ProgramHomeLoggedInQueryText, {
    skip: ({ userId, program, thirdPartyOrganization }) => !userId || !program || !thirdPartyOrganization,
    options: ({ program, thirdPartyOrganization, userId }) => ({
      variables: {
        programMembershipId: `${user.get()?.id}~${program.id}`,
        userId: userId.toString(),
        thirdPartyOrganizationId: thirdPartyOrganization.id,
        requirePreJoinCheck:
          thirdPartyOrganization.programVisibilityRule === PROGRAM_VISIBILITY_RULE.ACCEPTED_PRIVACY_NOTICE,
      },
    }),
    props: ({ data }) => {
      const programMembership = data?.ProgramMembershipsV2?.get?.elements?.[0];
      const isProgramMember = Boolean(programMembership?.membershipState === Member);
      return {
        programMembership,
        isProgramMember,
        membershipCreatedAt: programMembership?.createdAt,
        isMembershipLoading: data?.loading,
      };
    },
  })
);

export default withEnterpriseProgramMembership;
